import {fxxl_config_from_php} from '@fxxl/globals';

/**
 * Die Klasse "FxxlConfigs" stellt eine statische Methode "getConfig" bereit, die
 * ein Objekt mit verschiedenen Konfigurationen zurückgibt.
 */
export default class FxxlConfigs {
      constructor() {
    }

    static getConfig() {
          return {
              storageKeys: {
                  firstAction: 'fxxlStorageFirstAction',
                  utmSourceNewsletter: 'fxxlStorageUtmSourceNewsletter',
                  newsletterPopup: 'fxxlStorageNewsletterPopup',
                  shopSuggestion: 'fxxlStorageShopSuggestion',
                  pageSessionWertgarantieDeviceInsurancesPraefix: 'wg_insurance_premium_',
                  pageSessionWertgarantieViewedBikelockPopup: 'fxxl_wertgarantie_slider_first_view',
                  shopSuggestion: 'fxxlStorageShopSuggestion',
                  cmt: 'fxxlStorageCMT',
              },
              eventNames: {
                  firstAction: 'fxxl-first-action',
                  firstActionCached: 'fxxl-first-action-cached',
                  ready: 'fxxl-ready',
                  narrowerHasChanged: 'fxxl-narrower-has-changed',
                  narrowerRequestUpdate: 'fxxl-narrower-request-update',
                  narrowerRequestSubmit: 'fxxl-narrower-request-submit',
                  formValidation: 'fxxl-form-validation',
              },
              server: fxxl_config_from_php,
          };
    }
}